import { render } from "./ListeFichiersAffaire.vue?vue&type=template&id=5f85026a"
import script from "./ListeFichiersAffaire.vue?vue&type=script&lang=js"
export * from "./ListeFichiersAffaire.vue?vue&type=script&lang=js"

import "./ListeFichiersAffaire.vue?vue&type=style&index=0&id=5f85026a&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__